import { createTableSlice } from '../helpers';
import { TaskStatus } from '../../constants';

export const tableSlice = createTableSlice({
  name: 'actionRequiredTable',
  url: '/api/labelTasks/actionRequired',
  filters: {
    status: TaskStatus.PENDING,
  },
  sortOrder: 'asc',
  orderBy: 'LabelTask.id',
});
